import 'select2'

export function initSelects() {
  // const selects = document.querySelectorAll('select')

  // selects.forEach(select => {
  $('select:not([data-select2-dropdown])').select2({
    minimumResultsForSearch: -1,
    width: '100%',
  })
  $('select[data-select2-dropdown]').select2({
    dropdownParent: $('.js-select2-dropdown-parent'),
    minimumResultsForSearch: -1,
    width: '100%',
  })
  // })
}
